import React from 'react'
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import './App.css';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Projects from './pages/Projects';
import HireMe from './pages/HireMe';
import Footer from './components/Footer';
import ProjectDetails from './pages/ProjectDetails';
import About from './pages/About';
import { IKContext } from 'imagekitio-react'
import SocialIcons from './components/SocialIcons';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';
import ScrollToTop from './components/ScrollToTop';

// App content component that uses theme
const AppContent = () => {
  const { isDark } = useTheme();

  return (
    <IKContext urlEndpoint="https://ik.imagekit.io/pqi6rje32wn">
      <Router>
        <ScrollToTop />
        <div className={`md:px-20 px-6 relative min-h-screen list-none font-mono flex flex-col justify-between transition-colors ${
          isDark
            ? 'bg-dark-bg-primary text-dark-text-primary'
            : 'bg-light-bg-primary text-light-text-primary'
        }`}>
          {/* Navbar */}
          <Navbar />

          <Routes>
            <Route exact path="/" element={<Home />}></Route>
            <Route path="about" element={<About />}></Route>
            <Route path="projects" element={<Projects />}></Route>
            <Route path="projects/:projectId" element={<ProjectDetails />}></Route>
            <Route path="hireme" element={<HireMe />}></Route>
          </Routes>

          {/* Social Icons - Mobile only */}
          <div className='md:hidden block mb-20 mx-auto'><SocialIcons /></div>
        </div>

        {/* Footer */}
        <Footer />
      </Router>
    </IKContext>
  );
};

const App = () => {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
};

export default App
